<div class="cfg-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title"><i class="fal fa-question-circle"></i> FAQ</h1>
      <p class="page-header__sub">Base de connaissances & questions fréquentes — {{ faqs.length }} entrée(s)</p>
    </div>
    <div class="header-actions">
      <button class="btn-create" (click)="ouvrirCreation()"><i class="fal fa-plus"></i> Nouvelle entrée</button>
      <button class="btn-refresh" (click)="charger()" [disabled]="chargement">
        <i class="fal fa-sync" [class.fa-spin]="chargement"></i> Actualiser
      </button>
    </div>
  </div>

  <!-- KPI -->
  <div class="kpi-row">
    <div class="kpi-card"><span class="kpi-val">{{ faqs.length }}</span><span class="kpi-label">Questions</span></div>
  </div>

  <!-- Filtre -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltre()" placeholder="Rechercher une question ou une réponse…" />
    </div>
  </div>

  <!-- Chargement -->
  <div class="etat-centre" *ngIf="chargement"><div class="spinner"></div><span>Chargement…</span></div>

  <!-- Vide -->
  <div class="etat-centre" *ngIf="!chargement && faqsFiltrees.length === 0">
    <i class="fal fa-question-circle" style="font-size:36px;color:#cbd5e0"></i>
    <p>Aucune entrée FAQ trouvée.</p>
  </div>

  <!-- Accordéon -->
  <div class="faq-list" *ngIf="!chargement && faqsFiltrees.length > 0">
    <div class="faq-item" *ngFor="let f of faqsFiltrees; let i = index">
      <div class="faq-item__header" (click)="toggleAccordion(f.id)">
        <div class="faq-item__num">{{ i + 1 }}</div>
        <div class="faq-item__question">{{ f.question }}</div>
        <div class="faq-item__controls">
          <button class="btn-action btn-action--teal" (click)="ouvrirEdition(f); $event.stopPropagation()" title="Modifier">
            <i class="fal fa-pencil"></i>
          </button>
          <button class="btn-action btn-action--danger" (click)="supprimer(f); $event.stopPropagation()" title="Supprimer">
            <i class="fal fa-trash"></i>
          </button>
          <i class="fal chevron-icon"
             [ngClass]="faqOuverte === f.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
      </div>
      <div class="faq-item__body" [class.faq-item__body--open]="faqOuverte === f.id">
        <p>{{ f.reponse }}</p>
      </div>
    </div>
  </div>
</div>

<!-- MODAL -->
<div class="modal-backdrop" *ngIf="afficherModal" (click)="fermerModal()">
  <div class="modal-card modal-card--large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon" style="background:#fefce8;color:#ca8a04"><i class="fal fa-question-circle"></i></div>
        <div>
          <h3>{{ modeEdition ? 'Modifier la question' : 'Nouvelle entrée FAQ' }}</h3>
          <p class="modal-header__sub">Rédigez la question et sa réponse</p>
        </div>
      </div>
      <button class="modal-close" (click)="fermerModal()"><i class="fal fa-times"></i></button>
    </div>
    <div class="modal-body">
      <div class="modal-grid">
        <div class="modal-field modal-field--full">
          <label>Question <span class="required">*</span></label>
          <input type="text" [(ngModel)]="formulaire.question" placeholder="Ex: Comment suivre ma commande ?" />
        </div>
        <div class="modal-field modal-field--full">
          <label>Réponse <span class="required">*</span></label>
          <textarea rows="5" [(ngModel)]="formulaire.reponse"
                    placeholder="Rédigez une réponse claire et concise…"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-modal-cancel" (click)="fermerModal()"><i class="fal fa-times"></i> Annuler</button>
      <button class="btn-modal-primary" (click)="sauvegarder()" [disabled]="sauvegardeEnCours">
        <ng-container *ngIf="!sauvegardeEnCours"><i class="fal fa-check"></i> {{ modeEdition ? 'Mettre à jour' : 'Ajouter' }}</ng-container>
        <ng-container *ngIf="sauvegardeEnCours"><div class="spinner spinner--xs spinner--white"></div> Enregistrement…</ng-container>
      </button>
    </div>
  </div>
</div>
